import { useEffect, useState } from 'react';
import './UpdateLeadTodo.css';
import { getAllUsersBasic } from '../../utilities/api/users';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { updateLeadTodo } from '../../utilities/api/leads';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';



export default function UpdateLeadTodo({user, lead, todo, getLeadItem, toggleNotifications}) {
    const defaultState = {
        title: todo.title,
        description: todo.description,
        deadline: todo.deadline.split('T')[0],
        createdBy: todo.createdBy,
        createdByID: todo.createdByID,
        assignedTo: todo.assignedTo,
        assignedToID: todo.assignedToID,
        priority: todo.priority,
        status: todo.status,
    }
    const [formData, setFormData] = useState(defaultState)
    const [ users, setUsers ] = useState([])
    const disableFields = todo.status === 'complete'

    const getBasicUsers = async () => {
        try {
            const data = await getAllUsersBasic()
            const filteredData = data.filter(user => ['admin', 'manager'].includes(user.userType))
            setUsers(filteredData)
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = async (evt) =>{
        evt.preventDefault();
        // console.log(formData)
        try {
            const data = await updateLeadTodo(lead._id, todo._id, formData)
            setFormData(data)
            await toggleNotifications('success', `Todo "${capitalizeFirstLetter(todo.title)}" Updated!`, '#FFFFFF')
            formNotificationStyle2('leadTodoCreationNotification', 'Todo Updated!', '#0A7637', '1')
            await getLeadItem(lead._id)
        } catch (error) {
            await toggleNotifications('error', `Failed to Update Todo "${capitalizeFirstLetter(todo.title)}"!`, '#FFFFFF')
            formNotificationStyle2('leadTodoCreationNotification', 'Failed to Update Todo!', '#CA150C', '1')
            console.log(error)
        }
    }

    const handleChange = (evt) => {
        if (evt.target.name === 'assignedToID') {
            const selectedUser = users.find(user => user._id === evt.target.value)
            const newFormData = {
                ...formData,
                assignedTo: `${selectedUser.firstName} ${selectedUser.lastName}`,
                assignedToID: evt.target.value,
            };
            setFormData(newFormData);
        } else {
            const newFormData = {
                ...formData,
                [evt.target.name]: evt.target.value,
            };
            setFormData(newFormData);
        }
    }

    useEffect(() => {
        getBasicUsers()
    }, [])

    const disabled = !formData.title || !formData.deadline || !formData.assignedTo || !formData.priority
  return (
    <div className='NewLeadTodo modal fade' id={`updateLeadTodoModal${todo._id}`}  data-bs-keyboard="true">
        <div className="modal-dialog">
            <div className='modal-content formContainer'>
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                                <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="#1A5E9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                            </svg>
                        </div>
                        <div className='second'>
                        <div className='sec1'>
                            Update "<span className='primaryText'>{capitalizeFirstLetter(todo.title)}</span>"
                        </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                        <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <form onSubmit={handleSubmit} id={`updateLeadTodoForm${todo._id}`}>
                    <div className='formContent'>
                        <div className='title mb-3'>
                            <label htmlFor="title">Title <span className='requiredField'><strong>*</strong></span></label>
                            <input className='form-control' title='Todo Title' type="text" name="title" id="title" placeholder="Enter Todo Title" defaultValue={formData.title} onChange={handleChange} required autoComplete='off' disabled={disableFields}/>
                        </div>
                        <div className='deadline mb-3'>
                            <label htmlFor="deadline">Deadline <span className='requiredField'><strong>*</strong></span></label>
                            <input className='form-control' title='Deadline' type="date" name="deadline" id="deadline" defaultValue={formData.deadline} onChange={handleChange} required autoComplete='off' disabled={disableFields}/>
                        </div>
                        <div className='assignedToID mb-3'>
                            <label htmlFor="assignedToID">Assign To <span className='requiredField'><strong>*</strong></span></label>
                            <select className='form-select' title='Assign Todo' name="assignedToID" id="assignedToID" defaultValue={formData.assignedTo} onChange={handleChange} required disabled={disableFields}>
                                {users && users.map((userItem, index) => (
                                <option key={index} value={userItem._id}>{capitalizeFirstLetter(userItem.firstName)} {capitalizeFirstLetter(userItem.lastName)}</option>
                                ))}
                            </select>
                        </div>
                        <div className='priority mb-3'>
                            <label htmlFor="priority">Priority <span className='requiredField'><strong>*</strong></span></label>
                            <select className='form-select' title='Todo Priority' name="priority" id="priority" defaultValue={formData.priority} onChange={handleChange} required disabled={disableFields}>
                                <option value='low'>Low</option>
                                <option value='medium'>Medium</option>
                                <option value='high'>High</option>
                            </select>
                        </div>
                        <div className='status mb-3'>
                            <label htmlFor="status">Status <span className='requiredField'><strong>*</strong></span></label>
                            <select className='form-select' title='Todo Status' name="status" id="status" defaultValue={formData.status} onChange={handleChange} required>
                                <option value='inProgress'>In Progress</option>
                                <option value='complete'>Complete</option>
                            </select>
                        </div>
                        <div className='description mb-3'>
                            <label htmlFor="description">Description</label>
                            <textarea className='form-control' title='Description' rows={5} name="description" id="description" placeholder="Enter Description" defaultValue={formData.description} onChange={handleChange} autoComplete='off' disabled={disableFields}/>
                        </div>
                    </div>
                </form>
                <div className='d-flex justify-content-center formButtonContainer'>
                    <button data-bs-dismiss="modal" className='cancel'>Cancel</button>
                    <button data-bs-dismiss="modal" className="primary submit" type="submit" form={`updateLeadTodoForm${todo._id}`} disabled={disabled}>Save Changes</button>
                </div>
                <div id='leadTodoUpdateNotification'className='leadTodoUpdateNotification text-center mb-2'></div>
            </div>
        </div>
    </div>
  )
}
